'use strict';

var toastr = require('toastr');
var _ = require('lodash');
var FaresOptimizerAnalysisDataService = function FaresOptimizerAnalysisDataService($window, restangular, dataTransformService, $cacheFactory, FaresOptimizerConstants) {
  var recommendationLadderEndPoint = restangular.one('external').one('faresoptimizer').one('recommendationladder');
  var offerBasedFareLadder = restangular.one('external').one('offerFareLadder');
  var recalcCleanUpEndPoint = restangular.one('external').one('faresoptimizer').one('recommendationladder').one('expireRecommendationLadder');
  var failureAuditLogEndPoint = restangular.one('external').one('faresoptimizer').one('failureAuditLog').one('latest');
  var $cache = $cacheFactory(FaresOptimizerConstants.RECOMMENDATION_CACHE_KEY);
  function getRecommendationLadder(filter) {
    return recommendationLadderEndPoint.one('flattened').get({
      filter: filter,
      pageLimit: -1
    });
  }
  function getFailureAuditLog(failureAuditLogQuery) {
    return failureAuditLogEndPoint.customPOST(failureAuditLogQuery);
  }
  function getOfferBasedLadder(filter) {
    return offerBasedFareLadder.one('latest').one('ui').get({
      filter: filter,
      pageLimit: -1
    });
  }
  function getRecalculatedRecommendationLadder(fareRecordKey, selectedCompetitor, compFbc, compOrig, compDest, compTariffCode, compRoutingNumber, compFootnote, rbdVsEffectiveFares, smoothingMethod, compFareSource) {
    var payload = {
      recordKey: fareRecordKey,
      selectedCompetitor: selectedCompetitor,
      selectedCompetitorFbc: compFbc,
      competitorOrigin: compOrig,
      competitorDestination: compDest,
      competitorTariffCode: compTariffCode,
      competitorRoutingNumber: compRoutingNumber,
      competitorFootnote: compFootnote,
      rbdVsEffectiveFares: rbdVsEffectiveFares,
      smoothingMethod: smoothingMethod,
      competitorFareSource: compFareSource
    };
    var message = 'Recalculate';
    return recommendationLadderEndPoint.one('recalculate').customPOST(payload).then(function (data) {
      return data;
    })["catch"](function () {
      toastr.error(message + ' Failed');
      throw message + ' Failed';
    });
  }
  function deleteRecalculatedRecommendationLadder(val) {
    var payload = val;
    var message = 'Discard';
    return recalcCleanUpEndPoint.one('dissociateFares').customPUT(payload).then(function (data) {
      if (!_.isNil(data) && !_.isEmpty(data.failedMap)) {
        var values = _.values(data.failedMap);
        toastr.error(message + ' Failed. ' + values);
        return data;
      }
      $window.sessionStorage.removeItem(FaresOptimizerConstants.SESSION_STORAGE_KEYS.RECALCULATED);
      toastr.success(message + ' Successful');
      return data;
    })["catch"](function () {
      toastr.error(message + ' Failed');
      throw message + ' Failed';
    });
  }
  function alignFareRecommendations(alignLadderPayload, displayedRawData, rawData) {
    var message = 'Save adjustments ';
    return recommendationLadderEndPoint.one('align').customPOST(alignLadderPayload).then(function (data) {
      if (!_.isNil(data) && !_.isEmpty(data.failedMap)) {
        var values = _.values(data.failedMap);
        toastr.error(message + ' Failed. ' + values);
        return;
      }
      var updatedLadder = dataTransformService.transformRecommendationLadder(data)[0];
      dataTransformService.updateRecommendation(displayedRawData, updatedLadder);
      dataTransformService.updateRecommendation(rawData, updatedLadder);
      toastr.success(message + ' Successful');
      return data;
    })["catch"](function () {
      toastr.error(message + ' Failed');
      throw 'error';
    });
  }
  function getRecommendationData(filter, mode) {
    var cached = $cache.get(filter);
    if (!cached) {
      cached = mode !== 'ADAPTIVE' ? getRecommendationLadder(filter).then(dataTransformService.transformRecommendationLadder) : getOfferBasedLadder(filter).then(dataTransformService.transformRecommendationLadderAdaptive);
      $cache.put(filter, cached);
    }
    return cached;
  }
  function getFailureAuditLogData(failureAuditLogQuery) {
    var cached = $cache.get('AuditLog:' + Object.values(failureAuditLogQuery).join('.'));
    if (!cached) {
      cached = getFailureAuditLog(failureAuditLogQuery).then(dataTransformService.transformAuditLog);
      $cache.put('AuditLog:' + Object.values(failureAuditLogQuery).join('.'), cached);
    }
    return cached;
  }
  return {
    getRecommendationData: getRecommendationData,
    getFailureAuditLogData: getFailureAuditLogData,
    getRecalculatedRecommendationLadder: getRecalculatedRecommendationLadder,
    alignFareRecommendations: alignFareRecommendations,
    deleteRecalculatedRecommendationLadder: deleteRecalculatedRecommendationLadder
  };
};
FaresOptimizerAnalysisDataService.$inject = ['$window', 'Restangular', 'FaresOptimizerDataTransformerService', '$cacheFactory', 'FaresOptimizerConstants'];
module.exports = FaresOptimizerAnalysisDataService;